module.exports = __webpack_public_path__ + "static/media/ramraaj.58cf48a2.jpg";